import { defaultProductPhotoUrl } from '@iheartjane/menu';

import type { AlgoliaProduct } from '@jane/search/types';
import type {
  MaterializedMenuProduct,
  MenuProduct,
  PendingCartProduct,
} from '@jane/shared/types';

interface ProductImage {
  imageAlt: string;
  imageSrc: string;
}

interface ProductImages {
  images: ProductImage[];
  stockPhoto: boolean;
}

const productImages = (
  name: string,
  image_urls:
    | MenuProduct['image_urls']
    | AlgoliaProduct['image_urls']
    | PendingCartProduct['image_urls']
    | MaterializedMenuProduct['image_urls']
): ProductImage[] =>
  (image_urls ?? []).map((image_url) => ({
    imageAlt: name,
    imageSrc: image_url,
  }));

export const getProductImages = (
  product:
    | AlgoliaProduct
    | PendingCartProduct
    | MenuProduct
    | MaterializedMenuProduct
): ProductImages => {
  const { category, image_urls, kind, root_subtype, type, name } =
    product || {};

  const imageUrls =
    'photos' in product && product.photos?.length
      ? product.photos?.reduce((result: string[], { urls }) => {
          return [...result, urls.original];
        }, [])
      : image_urls;

  return {
    images: !imageUrls?.length
      ? [
          {
            imageAlt: `stock photo for ${type} ${root_subtype || ''}`,
            imageSrc: defaultProductPhotoUrl({
              category,
              kind,
              productRootSubtype: root_subtype,
              productType: type,
            }),
          },
        ]
      : productImages(name, imageUrls),
    stockPhoto: !imageUrls?.length,
  };
};
